interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  className?: string
}

export function Logo({ size = 'md', showText = true, className = '' }: LogoProps) {
  const sizes = {
    sm: { icon: 20, text: 'text-lg' },
    md: { icon: 24, text: 'text-xl' },
    lg: { icon: 32, text: 'text-2xl' },
  }

  const { icon, text } = sizes[size]

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-pulse-slow"
      >
        <defs>
          <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7C8CFF" />
            <stop offset="100%" stopColor="#5DE4C7" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        
        {/* Hexagon */}
        <path
          d="M16 2L28 9V23L16 30L4 23V9L16 2Z"
          stroke="url(#logo-gradient)"
          strokeWidth="2"
          fill="none"
          filter="url(#glow)"
        />
        
        {/* Inner circuit pattern */}
        <circle cx="16" cy="16" r="3" fill="url(#logo-gradient)" />
        <circle cx="12" cy="12" r="1.5" fill="#7C8CFF" />
        <circle cx="20" cy="12" r="1.5" fill="#5DE4C7" />
        <circle cx="12" cy="20" r="1.5" fill="#5DE4C7" />
        <circle cx="20" cy="20" r="1.5" fill="#7C8CFF" />
        
        {/* Connecting lines */}
        <line x1="16" y1="16" x2="12" y2="12" stroke="#7C8CFF" strokeWidth="1" opacity="0.6" />
        <line x1="16" y1="16" x2="20" y2="12" stroke="#5DE4C7" strokeWidth="1" opacity="0.6" />
        <line x1="16" y1="16" x2="12" y2="20" stroke="#5DE4C7" strokeWidth="1" opacity="0.6" />
        <line x1="16" y1="16" x2="20" y2="20" stroke="#7C8CFF" strokeWidth="1" opacity="0.6" />
      </svg>
      
      {showText && (
        <span className={`font-semibold tracking-tight text-text ${text}`}>
          softitect
        </span>
      )}
    </div>
  )
}
